// extracted by mini-css-extract-plugin
export default {"App":"app_App__VVUWJ","content":"app_content__1hX+9"};